export const ORGANIZATION_TRANSLATION_NAMESPACE = "organization";

export const ORGANIZATION_BILLING_VIEW_TK = "ORGANIZATION_BILLING_VIEW_TK";
export const ORGANIZATION_INVOICES_VIEW_TK = "ORGANIZATION_INVOICES_VIEW_TK";
export const ORGANIZATION_EXTERNAL_POS_TK = "ORGANIZATION_EXTERNAL_POS_TK";
